module.exports = __webpack_public_path__ + "static/media/TRADNG_PLATFORM.28cf0fb3.png";